export function TableLabel({ record, name, background}) {
    return (
        <div className="control is-fullwidth">
            {record[name]}
        </div>
    )
}